<template>
  <div class="collectAuction borderTop borderLRB">
    <div class="collectBox">
      <ul>
        <li v-for="(item, index) in list" :key="index" class="mt30">
          <div class="item">
            <div class="titleBox">
              <strong class="auctionFont">
                {{ item.title }}
              </strong>
              <span class="sendBut yahei" @click="sendButClick(item)"
                >提交拍品信息</span
              >
            </div>
            <div class="indoBox color333 font14">
              <div class="yahei">
                <strong>征集开始时间：</strong>{{ getMyDate(item.start_time) }}
              </div>
              <div class="yahei">
                <strong>征集结束时间：</strong>{{ getMyDate(item.end_time) }}
              </div>
              <div class="yahei">
                <strong>征集地点<em></em>：</strong>{{ item.place }}
              </div>
              <div class="yahei">
                <strong>征集项目<em></em>：</strong>{{ item.sort }}
              </div>
              <div class="auctionFont font12">
                <art-text-down
                  :default-line="2"
                  :text="item.descript"
                ></art-text-down>
              </div>
              <div class="zimg">
                  <el-image fit="cover" :src="item.cover"/>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "collectAuction",
  props: ["list"],
  data() {
    return {
      dataList: [{}, {}],
    };
  },
  methods: {
    sendButClick(item) {
      this.$emit("sendGoodClick",item.id);
    },
    getMyDate(timestamp) {
      var chinaStandard = timestamp;
      var date = new Date(chinaStandard);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
.collectAuction {
  padding: 20px 39px 15px 39px;
  ul {
    li {
      border-bottom: 1px solid #f2f2f2;
      padding-bottom: 30px;
      &:last-child {
        border-bottom: none;
      }
      .titleBox {
        display: inline-flex;
        justify-content: space-between;
        width: 100%;
        strong {
          font-size: 20px;
          line-height: 32px;
        }
        .sendBut {
          display: inline-block;
          height: 32px;
          background: #f2f2f2;
          text-align: center;
          line-height: 32px;
          font-size: 12px;
          font-weight: normal;
          padding: 0px 20px;
          margin-right: 11px;
          cursor: pointer;
          &:hover {
            background: #000000;
            color: #ffffff;
          }
        }
      }
      .indoBox {
        line-height: 30px;
        strong {
          em {
            width: 28px;
            display: inline-block;
          }
        }
      }
    }
  }
}
.zimg {
    width: 398px;
    height: 398px;
    .el-image {
        width: 100%;
        height: 100%;
    }
}
</style>
